import React from "react";
import { observer } from "mobx-react-lite";

const SearchResultsView = observer(({ results, loading, onAddToFavorites, isFavorite }) => {
  if (!results) return null;



  if (!loading && results.length === 0) {   //"no results found" shown only after the search is complete
    return <p className="no-results">No results found.</p>;
  }


  return (
    <div className="results-container">
      {results.map((artwork, index) => (
        <div key={index} className="artwork-card">
          <h3 className="artwork-title">{artwork.title}</h3>
          <p>
            <strong>Artist:</strong> {artwork.artistName || "Unknown"}
          </p>
          {artwork.image ? (
            <img
              src={artwork.image}
              alt={artwork.title}
              className="artwork-image"
            />
          ) : (
            <p>No image available.</p>
          )}
          <div className="favorites-button">
            <button
              className="add-to-favorites-button"
              onClick={() => onAddToFavorites(artwork)}
              disabled={isFavorite(artwork)}
            >
              {isFavorite(artwork) ? "Added to Favorites" : "Add to Favorites"}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
});

export default SearchResultsView;